const DrawLineIcon = ({ ...props }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <path d="M15 3L3 15" stroke="#0C0C0C" strokeWidth="1.5" />
            <rect x="13" y="2" width="3" height="3" fill="#0C0C0C" />
            <rect x="2" y="13" width="3" height="3" fill="#0C0C0C" />
        </svg>
    );
};

export default DrawLineIcon;
